import axios from "axios";

const client = (() => {
  return axios.create({
    baseURL: import.meta.env.VITE_API_URL,
  });
})();

const request = async <T,>(options: any): Promise<T> => {
  const onSuccess = (response: { data: T }) => response?.data;

  const onError = (error: any) => Promise.reject(error.response || error.message);

  return client(options).then(onSuccess).catch(onError);
};

export default request;
